// ============================================================================
// ENGLISH TRANSLATIONS - JESUS IS NOT...
// ============================================================================
// Important clarifications about who Jesus really is

export const jesusIsNot = [
  {
    category: "love",
    text: "Jesus is not homophobic - His infinite love includes everyone as they are",
    reference: "1 John 4:8 - God is love",
    context: "God's love is inclusive and accepts each person in their diversity"
  },
  {
    category: "equality",
    text: "Jesus is not misogynistic - His infinite love values every woman",
    reference: "Luke 8:1-3 - The women who followed Jesus",
    context: "Jesus revolutionizes his era by including and honoring women"
  },
  {
    category: "peace",
    text: "Jesus is not a murderer - His infinite love gives life to all",
    reference: "John 10:10 - I have come that they might have life",
    context: "Jesus brings life, healing and restoration to everyone"
  },
  {
    category: "unity",
    text: "Jesus is not divisive - His infinite love unites all humanity",
    reference: "Galatians 3:28 - There is neither Jew nor Greek",
    context: "Jesus' love transcends all human barriers"
  },
  {
    category: "love", 
    text: "Jesus is not racist - His infinite love embraces all cultures",
    reference: "Matthew 28:19 - Make disciples of all nations",
    context: "Jesus' love celebrates the diversity of all humanity"
  },
  {
    category: "justice",
    text: "Jesus is not an oppressor - His infinite love liberates and heals everyone",
    reference: "Luke 4:18 - He has sent me to proclaim freedom for the prisoners",
    context: "Jesus' love brings freedom and healing to all"
  },
  {
    category: "humility",
    text: "Jesus is not prideful - His infinite love serves everyone",
    reference: "Philippians 2:7 - He made himself nothing",
    context: "Jesus' love is expressed through humility and service"
  },
  {
    category: "forgiveness",
    text: "Jesus is not vengeful - His infinite love always forgives",
    reference: "Luke 23:34 - Father, forgive them for they know not what they do",
    context: "Jesus' love offers forgiveness even in suffering"
  },
  {
    category: "compassion",
    text: "Jesus is not insensitive - His infinite love feels every pain",
    reference: "John 11:35 - Jesus wept",
    context: "Jesus' love deeply shares our joys and sorrows"
  },
  {
    category: "truth",
    text: "Jesus is not a liar - His infinite love is pure truth",
    reference: "John 14:6 - I am the way, the truth and the life",
    context: "Jesus' love is the most authentic truth that exists"
  },
  {
    category: "peace",
    text: "Jesus is not violent - His infinite love brings true peace",
    reference: "Matthew 5:9 - Blessed are the peacemakers",
    context: "Jesus' love transforms conflicts into reconciliation"
  },
  {
    category: "generosity",
    text: "Jesus is not greedy - His infinite love gives without measure",
    reference: "2 Corinthians 8:9 - For your sake he became poor",
    context: "Jesus' love is generous to the point of giving everything"
  },
  {
    category: "love",
    text: "Jesus is not partial - His infinite love welcomes every unique being",
    reference: "Acts 10:34 - God does not show favoritism",
    context: "Jesus' love celebrates the uniqueness of each person, disability included"
  },
  {
    category: "universality",
    text: "Jesus has no borders - His infinite love surpasses all limits",
    reference: "Romans 10:12 - There is no difference between Jew and Gentile",
    context: "There are no borders for Jesus: neither geographical, nor cultural, nor social"
  },
  {
    category: "respect",
    text: "Jesus is not disrespectful - He teaches respect for self, women, and others",
    reference: "Matthew 22:39 - Love your neighbor as yourself",
    context: "Respect is certain wisdom: respect your life, your body, women as yourself, others"
  },
  {
    category: "peace",
    text: "Jesus is not divisive - He unites Jews, Arabs and all denominations in peace",
    reference: "Ephesians 2:14 - He is our peace, who has made the two groups one",
    context: "Let us celebrate our diversities rather than make them quarrels of words and wars"
  },
  {
    category: "truth",
    text: "Jesus is not a liar - He denounces lies and manipulation",
    reference: "John 8:44 - The devil is the father of lies",
    context: "Jesus exposes the lies and manipulations that wound souls"
  },
  {
    category: "generosity", 
    text: "Jesus is not greedy - His generosity far exceeds tithing",
    reference: "Luke 21:3 - This poor widow has put in more than all the others",
    context: "Jesus' generosity is stronger than the obligation of tithing"
  },
  {
    category: "justice",
    text: "Jesus is not complicit in silence - He protects through healthy justice",
    reference: "Matthew 18:6 - Whoever causes one of these little ones to stumble",
    context: "Silence that covers faults without protecting others is not Jesus' wisdom"
  }
];

export default jesusIsNot;